import React from "react";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import { makeStyles } from "@material-ui/core/styles";
import landingPage from "./carreers_edit.png";

const useStyles = makeStyles({
  media: {
    height: "18em",
  },
});

const Welcome = () => {
  const classes = useStyles();
  return (
    <Card>
      <CardMedia image={landingPage} className={classes.media} />
    </Card>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/Welcome.js